"use strict";

import { tns } from "tiny-slider/src/tiny-slider";

const media = {
  init: function () {
    media.slider();
    media.openHours();
    media.RWD();
    media.soundVideo();
  },

  // slider head des pages HOME + HOME CENTRE
  slider: function () {
    if (document.querySelector(".media_slider")) {
      let slides = document.querySelectorAll(".media_slide");
      if (slides.length > 1) {
        let slider = tns({
          container: ".media_slider",
          mode: "gallery",
          items: 1,
          autoplay: true,
          autoplayTimeout: 2500,
          // autoplayHoverPause: true,
          mouseDrag: true,
          controls: false,
          autoplayText: false,
          autoplayButton: false,
          autoplayButtonOutput: false,
          speed: 2000,
          loop: true,
        });

      }
    }
  },

  // changement des images sur mobile et desktop
  RWD: function () {
    let imgWrap = document.querySelectorAll(".img_rwd");
    if (imgWrap)
      imgWrap.forEach((img) => {
        let mobile = img.querySelector('[data-rwd="mobile"]');
        let desktop = img.querySelector('[data-rwd="desktop"]');
        let srcDesktop = desktop.getAttribute("srcset");

        if (mobile) {
          let srcMobile = mobile.getAttribute("srcset");
          window.innerWidth < 1024
            ? (img.style.backgroundImage = 'url("' + srcMobile + '")')
            : (img.style.backgroundImage = 'url("' + srcDesktop + '")');
        } else {
          img.style.backgroundImage = 'url("' + srcDesktop + '")';
        }
      });
  },

  // affichage des horaires d'ouvertures depuis l'API getHorairesOuverture
  openHours: function () {
    if (document.querySelector(".media_opening")) {
      try {
        let request = new XMLHttpRequest();
        request.open("GET", apiDataCentre.getHorairesOuverture);
        request.onreadystatechange = function () {
          if (request.readyState == 4 && request.status == 200) {
            let data = JSON.parse(request.responseText);
            document.querySelector(".media_opening").innerHTML = data.data.text;
          }
        };
        request.send();
      }
      catch(err) {
        // console.log(err)
      }
    }
  },

  // Gestion du son pour la banner video de la hp 
  soundVideo: function () {
    if (document.querySelector(".player_btnSound")) {
      const video = document.querySelector('.player_media');
      const playSoundBtn = document.querySelector('.player_btnSound');
      playSoundBtn.addEventListener('click', function () {
        if (video.muted) {
          video.muted = false;
          this.classList.add('sound-on')
        } else {
          video.muted = true;
          this.classList.remove('sound-on')
        }
      })
    }
  }
};

export default media;



// WEBPACK FOOTER //
// ./src/scripts/components/media.js